import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import { RouterModule } from '@angular/router';
import { mainRoutes } from './app.routes';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatDialogModule } from '@angular/material/dialog';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { EidosPaginatorI18n } from './eidos/models/eidos-paginator-i18n';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';
import { TranslocoRootModule } from './core/modules/transloco-root/transloco-root.module';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(mainRoutes, {
      onSameUrlNavigation: 'reload',
      scrollPositionRestoration: 'top'
    }),
    HttpClientModule,
    MatDialogModule,
    TranslocoRootModule
  ],
  providers: [
    {
      provide: MatPaginatorIntl,
      useClass: EidosPaginatorI18n
    },
    {
      provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
      useValue: { duration: 5000 }
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
